import { render, staticRenderFns } from "./viewMainCashier.vue?vue&type=template&id=0fd13ff9&scoped=true&"
import script from "./viewMainCashier.vue?vue&type=script&lang=js&"
export * from "./viewMainCashier.vue?vue&type=script&lang=js&"
import style0 from "./viewMainCashier.vue?vue&type=style&index=0&id=0fd13ff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd13ff9",
  null
  
)

export default component.exports